import { render } from "./BrilliantInk.vue?vue&type=template&id=398e980b&scoped=true"
import script from "./BrilliantInk.vue?vue&type=script&lang=js"
export * from "./BrilliantInk.vue?vue&type=script&lang=js"

import "./BrilliantInk.vue?vue&type=style&index=0&id=398e980b&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398e980b"]])

export default __exports__